import React, { Component } from 'react';
import PropTypes from 'prop-types';

import planeIcon from '../assets/images/01_Paroc_calculus_Icons.png';
import planeSelectedIcon from '../assets/images/01_Paroc_calculus_Icons.png';

import pipeIcon from '../assets/images/02_Paroc_calculus_Icons.png';
import pipeSelectedIcon from '../assets/images/02_Paroc_calculus_Icons.png';

import ductIcon from '../assets/images/03_Paroc_calculus_Icons.png';
import ductSelectedIcon from '../assets/images/03_Paroc_calculus_Icons.png';

import duct2Icon from '../assets/images/04_Paroc_calculus_Icons.png';
import duct2SelectedIcon from '../assets/images/04_Paroc_calculus_Icons.png';

import verticalCircularTankIcon from '../assets/images/05_Paroc_calculus_Icons.png';
import verticalCircularTankSelectedIcon from '../assets/images/05_Paroc_calculus_Icons.png';

import horizontalCircularTankIcon from '../assets/images/06_Paroc_calculus_Icons.png';
import horizontalCircularTankSelectedIcon from '../assets/images/06_Paroc_calculus_Icons.png';

import rectangularTankIcon from '../assets/images/07_Paroc_calculus_Icons.png';
import rectangularTankSelectedIcon from '../assets/images/07_Paroc_calculus_Icons.png';

import { CALCULATION_TYPE_PLANE, CALCULATION_TYPE_PIPE, CALCULATION_TYPE_DUCT, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK } from '../modules/calculation';
import { adobeClickInsulationObject } from '../utils/analytics';

class InsulatedButton extends Component {

  onClick = (type, e) => {
    if(this.props.onChange) {
      this.props.onChange(type);
    }
  }

  render() {
    const {label, selected, type} = this.props;

    let icon = planeIcon;
    let selectedIcon = planeSelectedIcon;

    if(type === CALCULATION_TYPE_PLANE) {
      icon = planeIcon;
      selectedIcon = planeSelectedIcon;
    } else if(type === CALCULATION_TYPE_PIPE) {
      icon = pipeIcon;
      selectedIcon = pipeSelectedIcon;
    } else if(type === CALCULATION_TYPE_DUCT || type === CALCULATION_TYPE_CIRCULAR_DUCT) {
      icon = ductIcon;
      selectedIcon = ductSelectedIcon;
    } else if(type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
      icon = duct2Icon;
      selectedIcon = duct2SelectedIcon;
    } else if(type === CALCULATION_TYPE_VERTICAL_TANK) {
      icon = verticalCircularTankIcon;
      selectedIcon = verticalCircularTankSelectedIcon;
    } else if(type === CALCULATION_TYPE_HORIZONTAL_TANK) {
      icon = horizontalCircularTankIcon;
      selectedIcon = horizontalCircularTankSelectedIcon;
    } else if(type === CALCULATION_TYPE_RECTANGULAR_TANK) {
      icon = rectangularTankIcon;
      selectedIcon = rectangularTankSelectedIcon;
    }

    return (
      <div className={'insulated-button ' + (selected ? ' selected' : '')} onClick={this.onClick.bind(this, type)}>
        <div className="img">
          <img className="normal-icon" src={icon} />
          <img className="selected-icon" src={selectedIcon} />
        </div>
        <label>{label}</label>
      </div>
    );
  }
}

InsulatedButton.propTypes = {
    label: PropTypes.string,
  onChange: PropTypes.any,
  selected: PropTypes.any,
  type: PropTypes.any,
};

export default InsulatedButton;
